import { render, staticRenderFns } from "./card_order_list.vue?vue&type=template&id=7565ce06&scoped=true"
import script from "./card_order_list.vue?vue&type=script&lang=js"
export * from "./card_order_list.vue?vue&type=script&lang=js"
import style0 from "./card_order_list.vue?vue&type=style&index=0&id=7565ce06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7565ce06",
  null
  
)

export default component.exports